'use client';

import classNames from 'classnames';
import * as React from 'react';
import { Button } from 'react-aria-components/Button';
import {
  DialogTrigger,
  DialogTriggerProps,
  Popover as ReactAriaPopover,
  PopoverProps as ReactAriaPopoverProps,
} from 'react-aria-components/Popover';

import Icon from '../Icon/Icon';
import css from './Popover.css';

type PopoverProps = DialogTriggerProps;

function Popover({ ...props }: PopoverProps) {
  return <DialogTrigger {...props} />;
}

interface PopoverTriggerProps {
  children: React.ReactNode;
  className?: string;
}

function PopoverTrigger({ children, className }: PopoverTriggerProps) {
  return (
    <Button className={classNames(css.trigger, className)}>
      <span>{children}</span>
      <Icon className={css.icon} name="angleDown" />
    </Button>
  );
}

interface PopoverContentProps extends Pick<ReactAriaPopoverProps, 'children' | 'placement' | 'offset'> {
  className?: string;
}

function PopoverContent({ className, placement = 'bottom start', offset = -1, ...props }: PopoverContentProps) {
  return (
    <ReactAriaPopover className={classNames(css.content, className)} placement={placement} offset={offset} {...props} />
  );
}

export { Popover, PopoverTrigger, PopoverContent };
